// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFilter24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.75 9.5V4.5H17.25V6H20C20.4142 6 20.75 6.33579 20.75 6.75C20.75 7.16421 20.4142 7.5 20 7.5H17.25V9.5H15.75ZM13 6C13.4142 6 13.75 6.33579 13.75 6.75C13.75 7.16421 13.4142 7.5 13 7.5H4C3.58579 7.5 3.25 7.16421 3.25 6.75C3.25 6.33579 3.58579 6 4 6H13ZM6.75 9.5V11H4C3.58579 11 3.25 11.3358 3.25 11.75C3.25 12.1642 3.58579 12.5 4 12.5H6.75V14.5H8.25V9.5H6.75ZM9.75 16.75C9.75 16.3358 9.41421 16 9 16H4C3.58579 16 3.25 16.3358 3.25 16.75C3.25 17.1642 3.58579 17.5 4 17.5H9C9.41421 17.5 9.75 17.1642 9.75 16.75ZM20.75 11.75C20.75 11.3358 20.4142 11 20 11H11C10.5858 11 10.25 11.3358 10.25 11.75C10.25 12.1642 10.5858 12.5 11 12.5H20C20.4142 12.5 20.75 12.1642 20.75 11.75ZM20 16C20.4142 16 20.75 16.3358 20.75 16.75C20.75 17.1642 20.4142 17.5 20 17.5H13.25V19.5H11.75V14.5H13.25V16H20Z"
				/>
			</Svg>
		);
	}
);
SvgFilter24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFilter24;
